// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAW0J8xA1XKlnfJVbmlaOrKdUckqzIRIR0",
    authDomain: "knitting-survey-pub.firebaseapp.com",
    projectId: "knitting-survey-pub",
    storageBucket: "knitting-survey-pub.appspot.com",
    messagingSenderId: "314579457096",
    appId: "1:314579457096:web:988e83a46a9fda80f4f47d",
    measurementId: "G-JJNF5SQKSL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);